<wvr-tabs-component>
  <ng-content select="template[tab-content]" ngProjectAs="template[tab-content]"></ng-content>
</wvr-tabs-component>
